import React from 'react';
import { Section, SectionHeading } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { ContentIcon } from '../ui/ContentIcon';
import { modules } from '../../data/content';
export function WhatsInside() {
  return <Section className="bg-cream" aria-labelledby="dentro-titulo" data-id="element-360" data-mp="1lia6ls4mm7f9">
      <Reveal data-id="element-361" data-mp="1gl1m3kw09rau">
        <SectionHeading id="dentro-titulo" data-id="element-362" data-mp="1gjgw88kmywjb">Dentro del protocolo</SectionHeading>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-muted" data-id="element-363" data-mp="1cjg6vsw010xh">
          Cuatro módulos y dos bonos. Todo en formato lectura rápida, para aplicar en la próxima
          comida.
        </p>
      </Reveal>

      <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-364" data-mp="12ls72ojjd38g">
        {modules.map((mod, index) => <Reveal as="li" key={mod.title} delay={index * 0.05} className="list-none" data-id="element-365" data-mp="xmpe42gtyngu" data-mpi={index}>
            <article className="flex h-full flex-col rounded-b-2xl border-t-[3px] border-gold bg-white p-7 shadow-card transition-[transform,box-shadow] duration-200 ease-smooth hover:-translate-y-0.5 hover:shadow-lift" data-id="element-366" data-mp="2wz0a33ho0l56">
              <span className="text-forest" data-id="element-367" data-mp="1knvk3udkib7u">
                <ContentIcon name={mod.icon} className="h-6 w-6" data-id="element-368" data-mp="1pnrohuq6g4nx" />
              </span>
              <p className="mt-5 text-xs font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-369" data-mp="1plew0nmsmbwm">
                {mod.label}
              </p>
              <h3 className="mt-2 text-lg font-bold leading-snug text-forest" data-id="element-370" data-mp="1fosd44e11ux8">{mod.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-371" data-mp="23emqqo667nij">{mod.description}</p>
            </article>
          </Reveal>)}
      </ul>
    </Section>;
}